const base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;

export function isBase64Encoded(str: string): boolean {
  return base64regex.test(str);
}

// In the browser, the atob and btoa functions are not guaranteed to work properly with non-UTF8 characters. Use the following helpers from tanstack instead

export function encodeToBase64(str: string): string {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (_, p1) => String.fromCharCode(parseInt(p1, 16))));
}

export function decodeFromBase64(str: string): string {
  return decodeURIComponent(Array.prototype.map.call(atob(str), (c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`).join(''));
}

export function decodeBase64IfNecessary(str: string): string {
  try {
    return isBase64Encoded(str) ? decodeFromBase64(str) : str;
  } catch {
    return str;
  }
}

export function isEncodedJson(str: string | undefined): boolean {
  if (!str) {
    return false;
  }

  if (!isBase64Encoded(str)) {
    return false;
  }

  try {
    const decoded = window.atob(str);
    JSON.parse(decoded);
    return true;
  } catch {
    return false;
  }
}

export function recursivelyDecodeBase64Json(input: string | undefined, depth: number = 0): unknown {
  if (!input) {
    return input;
  }

  try {
    const decoded = decodeBase64IfNecessary(input);
    const parsed = JSON.parse(decoded);

    if (typeof parsed === 'object' && parsed !== null) {
      for (const key in parsed) {
        switch (typeof parsed[key]) {
          case 'string':
            parsed[key] = recursivelyDecodeBase64Json(parsed[key], depth + 1);
            break;
          case 'object':
            parsed[key] = recursivelyDecodeBase64Json(JSON.stringify(parsed[key]), depth + 1);
            break;
        }
      }
    }

    return parsed;
  } catch {
    return !depth ? undefined : input;
  }
}
